'use client';

import { startTransition, useEffect, useState } from 'react';
import { Autocomplete } from '@/components/ui/autocomplete';
import { ExpandMoreIcon } from '@/components/ui/icons';
import { ListFilterDTO } from '@/features/filters/types/filters.dto';
import { productListUpdateFilters } from '@/features/products/state/list/actions';
import {
  useProductListDispatch,
  useProductListSelectedFilters
} from '@/features/products/state/list/context';
import { listingTranslate } from '@/i18n/translations/listingTranslations';

interface VoivodeshipProductsFilterProps extends ListFilterDTO {
  isMobile: boolean;
}

export const VoivodeshipProductsFilter = ({
  title,
  items,
  code,
  isMobile
}: VoivodeshipProductsFilterProps) => {
  const dispatch = useProductListDispatch();
  const selectedFilters = useProductListSelectedFilters();

  const selectedCode = String(selectedFilters[code]?.[0] || '');
  const [optimisticCode, setOptimisticCode] = useState(selectedCode);

  useEffect(() => {
    setOptimisticCode(selectedCode);
  }, [selectedCode]);

  const value = items.find((item) => item.code === optimisticCode) || null;

  const handleFiltersChange = (filterCode: string) => {
    setOptimisticCode(filterCode);
    startTransition(() => {
      dispatch(
        productListUpdateFilters({
          filterCategoryCode: code,
          code: filterCode
        })
      );
    });
  };

  if (!items.length) return null;

  return (
    <div className="px-4 mt-2">
      <Autocomplete
        disablePortal
        options={items}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.code === value.code}
        value={value}
        onChange={(_event, newValue) => {
          handleFiltersChange(newValue ? newValue.code : '');
        }}
        size={isMobile ? 'medium' : 'small'}
        label={title}
        renderOption={(option, _state, itemProps) => (
          <li key={option.code} {...itemProps} className={`${itemProps.className ?? ''} gap-1`}>
            <span>
              {option.name}{' '}
              {!!option.count && (
                <span className="text-sm text-(--mui-palette-text-disabled)">({option.count})</span>
              )}
            </span>
          </li>
        )}
        noOptionsText={listingTranslate('filters.no-option-text')}
        fullWidth
        popupIcon={<ExpandMoreIcon className="text-(--mui-palette-primary-main)" />}
      />
    </div>
  );
};
